export default "__VITE_ASSET__e4790601__"